import * as React from 'react';

import { BrowserRouter, Routes, Route } from 'react-router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { ExploreContainer } from './container/ExploreContainer';
import { NavBar } from './components/NavBar';
import { WelcomeContainer } from './container/WelcomeContainer';

import 'react-spring-bottom-sheet/dist/style.css';
import { ExploreProvider } from './context/ExploreContext';

function App() {
  const [locationFeature, setLocationFeature] = React.useState(null);

  const handleSetLocationFeature = (feature) => {
    setLocationFeature(feature);
  };

  const PUBLIC_URL = process.env.PUBLIC_URL || '';

  return (
    <div className='App'>
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route
            path={`${PUBLIC_URL}/`}
            element={
              <WelcomeContainer
                handleLocationFeature={handleSetLocationFeature}
              />
            }
          />
          <Route
            path={`${PUBLIC_URL}/explore`}
            element={
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <ExploreProvider
                  locationFeature={locationFeature}
                  handleLocationFeature={handleSetLocationFeature}
                >
                  <ExploreContainer
                    locationFeature={locationFeature}
                    handleLocationFeature={handleSetLocationFeature}
                  />
                </ExploreProvider>
              </LocalizationProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
